<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn class="mx-1" text color="grey" v-on="on">
        <v-img :src="idiomaSeleccionado.imagen" max-width="20" max-height="13"></v-img>
      </v-btn>
    </template>

    <v-card class="mx-auto" max-width="200">
      <v-list>
        <v-list-item-group v-model="indiceIdiomaSeleccionado" color="primary">
        <v-list-item v-for="(idioma, indice) in idiomas" :key="indice">
          <v-list-item-icon>
            <v-img :src="idioma.imagen" max-width="20" max-height="13"></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="idioma.titulo"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "SelectorIdioma",

  props: {
    value: { // codigo de idioma (P.Ej. "es_ES")
      type: String,
      required: true
    }
  },
  watch: {
    value: function (val) {
        this.indiceIdiomaSeleccionado = this.idiomas.findIndex (elemento => elemento.codigo == val)
    },
    indiceIdiomaSeleccionado: function(val) {
      this.$emit ("input", this.idiomas [val].codigo)
      this.$emit ("seleccion")
    }
  },
  data: () => ({
    idiomas: [
      { codigo: "es", imagen: require("@/assets/Españolflag.png"), titulo: "Español" },
      { codigo: "fr", imagen: require("@/assets/Françaisflag.png"), titulo: "Français" },
      { codigo: "en", imagen: require("@/assets/Englishflag.png"), titulo: "English" },
      { codigo: "ca", imagen: require("@/assets/Catalánflag.png"), titulo: "Catalán" }
    ],
    indiceIdiomaSeleccionado: 0
  }),
  created: function() {
    var indiceIdioma = this.idiomas.findIndex (elemento => elemento.codigo == this.value)
    if (indiceIdioma > -1)
      this.indiceIdiomaSeleccionado = indiceIdioma
  },
  computed: {
    idiomaSeleccionado: function() {
      return this.idiomas[this.indiceIdiomaSeleccionado]
    }
  }

}
</script>
